<h2 mat-dialog-title class="title-small">{{ title }}</h2>
<mat-dialog-content class="mat-typography" style="padding-top: 10px;">
    <form [formGroup]="form" fxLayout="column" fxLayoutGap="20px">
        <div class="full-width" fxLayout="column" fxLayoutGap="7px">
            <span class="body-1-regular-2" style="font-size: 11px;">{{ data.type === 'equipment' ? 'Equipment Name' :
                'Storage Unit Name' }}</span>
            <mat-form-field appearance="outline" class="custom-select-field" style="width: 100%;">
                <input matInput formControlName="equipmentName" placeholder="Enter name">
                <mat-error *ngIf="form.get('equipmentName')?.hasError('required')">
                    Name is required
                </mat-error>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="16px">
            <div fxFlex fxLayout="column" fxLayoutGap="7px">
                <span class="body-1-regular-2" style="font-size: 11px;">Total Capacity</span>
                <mat-form-field appearance="outline" class="custom-select-field" style="width: 100%;">
                    <input matInput type="number" formControlName="totalAmount" placeholder="0">
                    <mat-error *ngIf="form.get('totalAmount')?.hasError('required')">
                        Required
                    </mat-error>
                    <mat-error *ngIf="form.get('totalAmount')?.hasError('min')">
                        Min 0
                    </mat-error>
                </mat-form-field>
            </div>

            <div fxFlex fxLayout="column" fxLayoutGap="7px">
                <span class="body-1-regular-2" style="font-size: 11px;">Total Booked (Past 30 Days)</span>
                <mat-form-field appearance="outline" class="custom-select-field" style="width: 100%;">
                    <input matInput type="number" formControlName="bookedLast30Days" placeholder="0">
                </mat-form-field>
            </div>
        </div>

    </form>
</mat-dialog-content>
<mat-dialog-actions align="end" style="padding: 16px 24px;">
    <button mat-button (click)="onCancel()" class="body-1-regular-2">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="form.invalid">Update {{ data.type ===
        'equipment' ? 'Equipment' : 'Storage' }}</button>
</mat-dialog-actions>
